import { computed } from '@vue/composition-api'
import useForm from '@/compositions/useForm'
import { required, validAddressPickerIf } from '@/utils/validations'
import useRequest from '@/compositions/useRequest'
import LocationSearch from '@/components/LocationSearch/LocationSearch'

export default ({
  props: {
    item: Object,
    myOffer: Object,
  },
  components: {
    LocationSearch,
  },
  setup(props, context) {
    const { $store } = context.root
    const { emit } = context
    const isCash = computed(() => props.item.payment === 'cash')
    const price = computed(() => ((props.myOffer?.price % 1) ? parseFloat(props.myOffer?.price).toFixed(1) : Math.round(props.myOffer?.price)))

    const { makeRequest, loading } = useRequest({
      context,
      successMessage: 'Тендер обновлен!',
      request: data => $store.dispatch('materialDeliveries/updateOffer', data),
    })

    const editable = computed(() => !!props.myOffer)
    const showAddressForm = computed(() => props.item?.deliveryType === 'pickup')

    const {
      formData, validate, $errors, getData,
    } = useForm({
      fields: {
        price: { default: price.value || '', validations: { required } },
        address: { default: { address: '', position: null }, validations: { validAddressPicker: validAddressPickerIf(() => showAddressForm.value) } },
      },
    })

    if (props.myOffer?.address) formData.address.value = { address: props.myOffer?.address, position: null }

    const setAddress = async () => {
      const { address } = getData().address
      const ls = context.refs.locationSearch
      if (!address || !ls) return
      await ls.setAddress(address)
    }

    const submit = async () => {
      await setAddress()
      if (!validate()) return
      await makeRequest({
        id: props.item.id,
        data: {
          price: getData().price,
          address: getData().address?.address,
          position: getData().address?.position,
        },
      })
      emit('update')
    }


    return {
      editable,
      formData,
      validate,
      isCash,
      $errors,
      getData,
      showAddressForm,
      submit,
      loading,
    }
  },
})
